module.exports = __webpack_public_path__ + "static/media/logo.min.d80fc7b6.svg";